"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withProp = exports.switchProp = exports.ifProp = exports.prop = void 0;
const styled_tools_1 = require("styled-tools");
exports.prop = styled_tools_1.prop;
exports.ifProp = styled_tools_1.ifProp;
exports.switchProp = styled_tools_1.switchProp;
exports.withProp = styled_tools_1.withProp;

//# sourceMappingURL=tools.js.map
